import { InjectionToken } from '@angular/core';

export const THEME_URL = new InjectionToken<string>('settingThemeUrl');
export const THEME_TYPE = new InjectionToken<string>('settingThemeType');
